import './Checkbox.less';

import { useReframe } from 'nike-re-framejs';
import React, { FC, MouseEventHandler, ReactNode } from 'react';
import { bool, makeField, NfCheckbox } from 'nike-form-js';
import CheckButton from './CheckButton';
import FieldErrors from './FieldErrors';

interface CheckboxProps {
    form?: any;
    path?: any;
    className?: string;
    disabled?: boolean;
    onClick?: MouseEventHandler;
    useLabel?: boolean;
    dataAtid?: string;
    children?: ReactNode;
}

const Checkbox: FC<CheckboxProps> = ({
    form,
    path,
    className = '',
    disabled = false,
    onClick = null,
    useLabel = true,
    dataAtid,
    children
}) => {
    const { deref } = useReframe();
    const field = makeField(form, path, bool()),
        isTouched = deref(field.isTouched()),
        errors = deref(field.getErrors()),
        isError = isTouched && errors.size > 0;
    const active = deref(field.getValue());

    let attrs = {
        disabled: disabled,
        id: path,
        className: 'nui-native-input'
    };

    if (typeof onClick === 'function') {
        // @ts-ignore
        attrs.onClick = onClick;
    }

    const button = (
        // @ts-ignore
        <CheckButton active={active} className={className}>
            {children}
        </CheckButton>
    );

    return (
        <div className="nui-checkbox" data-atid={dataAtid}>
            <NfCheckbox field={field} value={true} attrs={attrs} />
            {useLabel ? <label htmlFor={path}>{button}</label> : button}
            {isError ? <FieldErrors errors={errors} className /> : null}
        </div>
    );
};

export default Checkbox;
